import * as React from "react";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = "", rows = 4, ...props }, ref) => {
    const base =
      "flex w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-900 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-800 focus:border-neutral-800 disabled:cursor-not-allowed disabled:opacity-50 resize-y min-h-[96px]";
    return <textarea ref={ref} className={`${base} ${className}`} rows={rows} {...props} />;
  }
);

Textarea.displayName = "Textarea";

